export const selectors = {
  toolExtOpen: state => state.toolExt.toolExtOpen
};
